import { Grid } from '@mui/material';
import {
  ActivitiesCard,
  Button,
  Label,
  Pagination,
  PageBanner,
} from 'app/components';
import GlobalKidsHand from 'app/libs/assests/global-kids-hands.png';
import ArticleBackground from 'app/libs/assests/article-background.png';
import { useNavigate } from 'react-router-dom';
import styles from './article-listing.module.scss';
import { ARTICLE_DETAIL, MANAGE_ARTICLE } from 'app/libs/constants/tab-routes';
import { ReactComponent as FilterIcon } from 'app/libs/assests/filter-icon.svg';

export const ArticleListing = () => {
  const dummyData = [1, 2, 3, 4];
  const dummyData1 = [1, 2];
  const stepper = ['pages', 'articles'];
  const navigate = useNavigate();
  return (
    <div className={styles['container']}>
      <PageBanner
        imageSrc={ArticleBackground}
        heading={'Articles'}
        stepperList={stepper}
      />
      <div className={styles['section-container']}>
        <Grid container spacing={6}>
          <Grid item md={9}>
            <div className={styles['header-container']}>
              <Label>32 Article</Label>
              <Button Component={FilterIcon}>Search Filter</Button>
            </div>
            <Grid container spacing={2}>
              {dummyData.map((el) => {
                return (
                  <Grid item md={6}>
                    <ActivitiesCard
                      imgSrc={GlobalKidsHand}
                      author={'Shivani Thakur'}
                      isBlog
                      date={'17 Aug, 2021'}
                      commentCounts={'3'}
                      heading={
                        'The passage experienced a surge in popularity during the 1960s.'
                      }
                      label={
                        'Lorem ipsum is simply free text used by copytyping refreshing. Neque porro est qui dolorem ipsum quia quaed inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.'
                      }
                      onClick={() => {
                        navigate(ARTICLE_DETAIL);
                      }}
                      onManage={() => {
                        navigate(MANAGE_ARTICLE);
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <Pagination count={3} />
          </Grid>
          <Grid item md={3}>
            <div className={styles['header-container']}>
              <Label>Recent Article</Label>
            </div>
            <Grid container rowGap={2}>
              {dummyData1.map((el) => {
                return (
                  <Grid item md={12}>
                    <ActivitiesCard
                      imgSrc={GlobalKidsHand}
                      author={'Shivani Thakur'}
                      isBlog
                      date={'17 Aug, 2021'}
                      commentCounts={'3'}
                      heading={
                        'The passage experienced a surge in popularity during the 1960s.'
                      }
                      label={
                        'Lorem ipsum is simply free text used by copytyping refreshing. Neque porro est qui dolorem ipsum quia quaed inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.'
                      }
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};
